export default {
  reports: {
    usersByStatus: "Utilisateurs par statut",
    usersByGender: "Utilisateurs par genre",
    gen: "Genre",
    gender: "Graphique du genre",
    male: "Homme",
    female: "Femme",
    other: "Autre",
    unspefied: "Non spécifié",
    byCountry: "Par pays",
    avgPriceFarmer: "Prix de vente moyen par tous les agriculteurs",
    avgPrice: "Prix de vente moyen par agriculteur",
    selectYear: "Sélectionner l'année",
    total: "Total",
    farmerName: "Nom de l'agriculteur",
    farmerProdChart: "Graphique de production de l'agriculteur",
    production: "Production",
    byProduction: "Par production",
    byName: "Par nom",
    descending: "Décroissant",
    ascending: "Croissant",
    buyingStationProdChart: "Graphique de production de la station d'achat",
    buyingStation: "Station d'achat",
    buyingStationName: "Nom de la station d'achat",
    dryMilling: "Broyage à sec",
    dryMillingName: "Nom du broyage à sec",
    dryMillingProdChart: "Graphique de production du broyage à sec",
    view: "Voir",
    date: "Date",
    reports: "Rapports",
    today: "Aujourd'hui",
    week: "Semaine",
    month: "Mois",
    year: "An",
    all: "Tout",
    selectCrop: "Sélectionner la culture",
    selectRegion: "Sélectionner la région",
    selectProvinceState: "Sélectionner la province/État",
    downloadPdfReport: "Télécharger le rapport PDF",
    export: "Exporter",
    search: "Rechercher",
    yield: "Rendement",
    avgAreaPerUnit: "Surface moyenne en {unit}",
    yieldPerUnit: "Rendement/{unit}",
    averageSellingPriceByAllFarmers: "Prix moyen de vente par tous les agriculteurs",
    averageSellingPricePerFarmer: "Prix moyen de vente par agriculteur",
    pricePaid: "Prix payé",
    pests: {
      pestReport: "Rapport sur les nuisibles",
      filterByCrops: "Filtrer par culture",
      pestStatistics: "Statistiques sur les nuisibles",
      regions: "Régions",
      occurrences: "Occurrences",
      pestChart: "Graphique des nuisibles",
      totalArea: "Surface totale",
      pestName: "Nom du nuisible",
      region: "Région",
      crop: "Cultures",
      listByLand: "Lister par terrain",
    },
    regions: {
      regionalReport: "Rapport régional",
      listByFarm: "Lister par ferme",
      listByFarmers: "Lister par agriculteurs",
      listByYield: "Lister par rendement",
      regionalStatistics: "Statistiques régionales",
      countries: "Pays",
      states: "États/Provinces",
      city: "Ville/Village",
      farmsIn: "Ferme(s) dans",
      regionalChart: "Graphique régional",
      farms: "Fermes",
      regionName: "Nom de la région",
      farmers: "Agriculteurs",
      yield: "Rendement/acre",
    },
    dashboard: {
      topCharts: "Graphiques principaux",
      regions: "Régions",
      noOfFarms: "Nombre de fermes/région",
      provinces: "Provinces/États",
      landArea: "Surface de terrain",
      avgFarmerLand: "Surface moyenne par agriculteur",
      viewAll: "Voir tout",
      crops: "Cultures",
      plantedAreaCrop: "Surface plantée par culture",
      plantedArea: "Surface plantée",
      avgYieldCrop: "Rendement moyen par culture",
      averageYield: "Rendement moyen",
      yieldChart: "Graphique de rendement",
      selectFarm: "Sélectionner la ferme",
      soilQuality: "Qualité du sol",
      pests: "Nuisibles",
      occurrences: "Occurrences",
      equipments: "Équipements",
      goalAchievedChart: "Graphique des objectifs atteints",
      soilValues: "Valeurs du sol",
      soil: "Sol",
      showReport: "Afficher les rapports sur le tableau de bord",
      selectAll: "Sélectionner tout",
    },
    weight: "Poids",
    quality: "Qualité",
    price: "Prix",
  },
}
